import { yupResolver } from "@hookform/resolvers/yup";
import FormButtons, { FormButtonInterface } from "components/forms/buttons";
import { CancelButton, SubmitButton } from "components/forms/buttons.utils";
import Form from "components/forms/form";
import Col from "components/grid/col";
import Grid from "components/grid/grid";
import Row from "components/grid/row";
import { FunctionComponent } from "react";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import Checkbox from "components/forms/inputs/checkbox";
import { useListUser } from "stores/hooks/list-user";
import { faTrash } from "components/icon-library";

interface DeleteModalFormProps {
  onSubmit: () => Promise<any>;
  onClose: () => Promise<void>;
}

const DeleteModalForm: FunctionComponent<DeleteModalFormProps> = ({
  onClose,
  onSubmit,
}) => {
  const user = useListUser();

  const schema = yup
    .object({
      confirm: yup.boolean().validateRequired(),
    })
    .required();

  const methods = useForm({
    mode: "onSubmit",
    reValidateMode: "onChange",
    resolver: yupResolver(schema),
    defaultValues: {
      confirm: false,
    },
  });

  const handleSubmit = async () => {
    onSubmit();
  };

  const buttons: FormButtonInterface[] = [
    { ...CancelButton, onClick: onClose },
    { ...SubmitButton, text: "Vahvista", postIcon: faTrash },
  ];

  if (!user) {
    return null;
  }

  return (
    <Form methods={methods} onSubmit={handleSubmit}>
      <Grid>
        <Row>
          <Col>
            Ilmoitusvelvollisen poistoa ei pysty peruuttamaan, vaan
            ilmoitusvelvollinen kaikkine tietoineen poistetaan palvelusta.
          </Col>
        </Row>
        <Row>
          <Col>
            <Checkbox
              name="confirm"
              label="Haluan poistaa ilmoitusvelvollisen"
            />
          </Col>
        </Row>
        <FormButtons buttons={buttons} />
      </Grid>
    </Form>
  );
};

export default DeleteModalForm;
